module.exports = __webpack_public_path__ + "static/media/cloud-download.034f870d.svg";